import { FirebaseAgents } from './index'
import mapper from './mapper'

const agentsDb = () => {

    const findOne = async (agentId) => {
        const agentDoc = await FirebaseAgents.doc(agentId).get()
        return (agentDoc.exists) ? mapper.get(agentDoc) : null
    }
    
    const findAll = () => {
        let query = FirebaseAgents.orderBy('name')
        return query
    }

    const update = (agentId, delta) => {
        return FirebaseAgents.doc(agentId).update(delta)
    }

    return Object.freeze({
        findOne,
        findAll,
        update
    })

}

const Agents = agentsDb()

export { Agents }
